<template>
    <div>

        <form>

            <div class="message-to-read success mb-3" v-if="success">
                👋 Thank you for your message, we'll get back to you as soon as we can.
            </div>

            <div class="message-to-read error mb-3" v-if="errors && errors.length">
                😔 Sorry something went a little wrong, please correct the errors below and try again.
            </div>

            <div class="flex flex-wrap">

                <div class="w-full md:w-1/2 md:pr-2">
                    <label class="block capitalize text-sm" for="name">Your name</label>
                    <input type="text" autocomplete="name" id="name" v-model="form.name">
                    <div class="error" v-if="hasError('name')">
                        {{ getError('name') }}
                    </div>
                </div>

                <div class="w-full md:w-1/2 mt-2 md:mt-0">
                    <label class="block capitalize text-sm" for="email">Your Email</label>
                    <input type="email" autocomplete="email" id="email" v-model="form.email">
                    <div class="error" v-if="hasError('email')">
                        {{ getError('email') }}
                    </div>
                </div>

                <div class="w-full mt-2" v-if="topics && topics.length > 0">
                    <label class="block capitalize text-sm" for="topic">Topic</label>
                    <select id="topic" v-model="form.topic">
                        <option :value="null" selected="selected">Please select...</option>
                        <option v-for="topic in topics" :value="topic.topic_label">{{ topic.topic_label}}</option>
                    </select>
                    <div class="error" v-if="hasError('email')">
                        {{ getError('email') }}
                    </div>
                </div>

                <div class="w-full mt-2">
                    <label class="block capitalize text-sm" for="message">Your Message</label>
                    <textarea name="message" id="message" cols="30" rows="10" v-model="form.message"></textarea>
                    <div class="error" v-if="hasError('message')">
                        {{ getError('message') }}
                    </div>
                </div>

            </div>

            <div class="mt-2">
                <slot></slot>
            </div>

            <div class="mt-2">
                <button :disabled="!valid" @click.prevent="send" :class="{ 'hover-blue hover:text-white' : valid, 'cursor-not-allowed opacity-50' : !valid }" class="inline-block bg-primary rounded px-2 text-white no-underline leading-loose capitalize text-1">Send message</button>
            </div>

        </form>

    </div>
</template>

<script>
    import { find, first } from 'underscore';

    export default {

        name: 'ContactForm',

        props: {
            endpoint:{
                type: String,
                required: true
            },
            topics: {
                type: Array,
                required : false
            },
        },

        data() {
            return {
                busy: false,
                success: false,
                errors: [],
                form: {
                    name: null,
                    email: null,
                    message: null,
                    topic: null,
                },
            }
        },

        computed: {

            valid() {
                return this.form.name && this.form.email && this.form.message;
            },

        },

        methods: {

            hasError(field) {
                return find(this.errors, error => {
                    return error.param === field;
                });
            },

            getError(field) {
                const errors = this.hasError(field);

                if (errors) {
                    return first(errors.messages);
                }
            },

            send() {
                if (!this.valid) {
                    return console.error('form data not valid', this.form);
                }

                this.errors = [];
                this.success = false;

                axios
                    .post(this.endpoint, this.form)
                    .then(() => {

                        this.success = true;
                        this.form.message = null;

                        this.$nextTick(() => {
                            scrollToErrors.scrollNow();
                        });
                    })
                    .catch(({ response }) => {
                        this.errors = response.data.data;

                        this.$nextTick(() => {
                            scrollToErrors.scrollNow();
                        });
                    });
            },

        },

    }
</script>

<style scoped>

    label {
        margin-bottom: 10px;
    }

    input,
    select,
    textarea {
        display: block;
        width: 100%;
        height: 40px;
        padding-left: 10px;
        line-height: 40px;
        border: 1px solid #d0d0d0;
        -webkit-appearance: none;
    }

    textarea {
        min-height: 200px;
        height: 200px;
    }

    .error {
        margin-top: 10px;
        background: #c40063;
        color: #fff;
        padding: 15px;
    }

    .success {
        background: pink;
        padding: 15px;
        background: #3d75b9;
        color: #fff;
    }

</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/ContactForm.vue